import { Component, OnInit, Input } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";

import { AfterViewInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";

import { merge, Observable, of as observableOf } from "rxjs";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { Dossier } from 'src/app/suivi-portefeuille/core/model/dossier';
import { DossierService } from 'src/app/suivi-portefeuille/core/service/dossier.service';
import { PortefeuilleTabsComponent } from '../portefeuille-tabs.component';
import { MatTableDataSource } from '@angular/material';
import { EtatCreance } from 'src/app/suivi-portefeuille/core/model/EtatCreance';
import { EtatCreanceService } from 'src/app/suivi-portefeuille/core/service/etat-creance.service';


@Component({
  selector: "app-etat-creance",
  templateUrl: "./etat-creance.component.html",
  styleUrls: ["./etat-creance.component.scss"]
})
export class EtatCreanceComponent implements OnInit {
  dossiers: Dossier[];

  @Input() numDossier: String;

  displayedColumns: string[] = [
    "numDossier",
    "typeEtatCreance",
    "dateEtatCreance",
    "dateEcheanceEnCours",
    "impayeJour",
    "createdAt",
  ];

  resultsLength = 0;
  isRateLimitReached = false;

  @ViewChild(MatPaginator, { static: false })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: false })
  sort: MatSort;
  dataSource: MatTableDataSource<EtatCreance>;
  isLoadingResults = false;

  data: EtatCreance[] = [];

  constructor(
    private modalService: NgbModal,
    private _router: Router,
    private _dossierService: DossierService,
    private _etatCreanceService: EtatCreanceService
  ) {}
  ngOnInit(): void {
    this.getEtatCreanceListByNumDossiers(this.numDossier);
  }

  ngAfterViewInit() {
    this.getEtatCreanceListByNumDossiers(this.numDossier);
  }

  getEtatCreanceListByNumDossiers(numDossier) {
    this.isLoadingResults = true;
    this._etatCreanceService
      .getEtatCreanceListByNumDossier(numDossier)
      .subscribe(
        data => {
          console.log("+++" + data);
          this.data = data;
        },
        error => {
          console.log(error);
          this.isLoadingResults = false;
        },
        () => {
          if (this.data == null) {
            this.data = [];
          }
          this.dataSource = new MatTableDataSource(this.data);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.isLoadingResults = false;
        }
      );
  }
}
